<template>
  <div class="transportation-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="transportation-content">
      <h4 class="transportation-h4 indent" id="transportation-7">Marino</h4>
      <p class="transportation-p indent">L'uso dell'alluminio nelle applicazioni marine può aumentare la velocità e le dimensioni di barche, yacht, traghetti e navi, migliorando al contempo i consumi di carburante, la navigabilità, la sicurezza, l'affidabilità e i costi di manutenzione.</p>
      <p class="transportation-p indent">In molti casi, gli estrusi integralmente induriti e meccanicamente incastrati sono utilizzati per ponti, coperture e altre strutture con estrusi convenzionali saldati e lamiere utilizzate per scafi e telai.</p>
      <div class="transportation-img" :style="{backgroundImage: 'url(' + '/static/img/markets/transportation/img_6.jpg' + ')'}"></div>
      <h4 class="transportation-h4 indent" id="transportation-8">Ferroviario</h4>
      <p class="transportation-p indent">Nei vagoni ferroviari l'alluminio consente ai costruttori di ridurre di un terzo il peso rispetto alle carrozze in acciaio. Nei sistemi ferroviari a transito rapido e suburbani, dove i treni devono fare molte fermate, si possono ottenere risparmi significativi in quanto è necessaria meno energia per l'accelerazione e la frenata delle vetture in alluminio. Inoltre, le carrozze in alluminio sono più facili da produrre e contengono un numero significativamente inferiore di componenti.</p>
      <div class="transportation-img" :style="{backgroundImage: 'url(' + '/static/img/markets/transportation/img_7.jpg' + ')'}"></div>
      <h4 class="transportation-h4 indent" id="transportation-9">Camion e rimorchi (Veicoli commerciali)</h4>
      <p class="transportation-p indent">L'alluminio riduce la massa a vuoto del veicolo. Nel trasporto di merci ad alta densità, in cui di solito si satura il peso massimo lordo del veicolo, l'alluminio consente di caricare più merci. Questo si traduce in un aumento del reddito e/o una migliore competitività, riducendo al tempo stesso le emissioni di CO2. </p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["transportation-7", "Marino"],
        ["transportation-8", "Ferroviario"],
        ["transportation-9", "Camion e rimorchi (Veicoli commerciali)"]
      ]
    };
  }
};
</script>

<style scoped>
.transportation-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.transportation-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.transportation-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.transportation-link {
  font-size: 19px;
  text-decoration: underline;
}
.transportation-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.transportation-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .transportation-content {
    width: 100%;
  }
  .transportation-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .transportation-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .transportation-link {
    font-size: 16px;
  }
  .transportation-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Transportation.vue